import { adminHttpClient } from '../commons/adminHttpClient'
import { NamedItemInt } from '../../domain/common/namedItem'

export interface InsurancePremiumResponse {
  id: string
  name: string
  recurringExpenses: RecurringExpenseResponse[]
}

export type RecurringExpenseResponse = {
  id: string
  requestedAmount: number
  startDate: string
  endDate: string
  expenseStatus: number
  expenseType: NamedItemInt
  messageToEmployee?: string
}

export const getInsurancePremiums = (planPeriodId: string): Promise<InsurancePremiumResponse[]> => {
  return adminHttpClient.get(`/Expenses/InsurancePremiums/${planPeriodId}`)
}
